import { getID } from "src/libs/utilities"


const vernissage = (): any[] => {
    return [
        {
          "id": getID("vernissage"),
          "type": "vernissage",
          "animated": ["fadeInLeft", "fadeInRight"],
          "animated_delay": "waterfall",
          "hover_size": 7,
          "text": {
            "text": "<p>Фотограф Alex Teuscher решил отправиться на поиски приключений. Он сделал серию невероятных снимков множества храмов, которые мелькали в фильмах с участием Анджелины Джоли, в частности в дилогии “Лара Крофт”. Предлагаем насладиться этой красотой и окунуться в мир прекрасного.<p>Храм Bayon предположительно был построен в 12-13 веке. Некоторые его части разрушились, но многие колонны до сих пор непоколебимо стоят."
          },
          "cover": {
            "src": "https://i.pinimg.com/736x/ff/56/c9/ff56c9606d2689209a879293537d4329.jpg",
            "link_url": "https://ru.pinterest.com/pin/120963939985867083/",
            "link_target": "_blank",
            "title": "hyperioner",
            "src_type": "div"
          },
          "coverTitle": { "text": "Hyperions" },
          "coverTitle2": { "text": "Daniel Simmons" },
          "order": {
            "type": "data_content",
            "id": getID("data_content"),
            "data": [
              {
                "type": "icon",
                "id":getID("image"),
                "style": {
                  "fontSize": 24,
                  "fontWeight": 100,
                  "textAlign": "center"
                },
                "src": "far fa-grin-tongue-wink fa-1x"
              }
            ]
          },
          "image0": {
            "src": "https://i.pinimg.com/736x/4f/80/99/4f80992592a8408369b8c46b21c897d6.jpg",
            "title": "Крестоформ",
            "link_url": "https://ru.pinterest.com/pin/13018286422333725/",
            "link_target": "_blank",
            "src_type": "div"
          },
          "image1": {
            "src": "https://i.pinimg.com/1200x/a3/92/e4/a392e4a67a968e579bb2b094b0f46997.jpg",
            "title": "Белый схимник",
            "link_url": "https://ru.pinterest.com/pin/5066618330203058/",
            "link_target": "_blank",
            "src_type": "div"
          },
          "image2": {
            "src": "https://i.pinimg.com/736x/80/13/72/801372184bf38b1efd43deea98c562ea.jpg",
            "title": "Нагайна",
            "link_url": "https://ru.pinterest.com/pin/11892386513306541/",
            "link_target": "_blank",
            "src_type": "div"
          },
          "image3": {
            "src": "https://i.pinimg.com/1200x/55/ef/cf/55efcf551067976bd1ba62a339a6e50b.jpg",
            "title": "Дэви",
            "link_url": "https://ru.pinterest.com/pin/4855512094412977/",
            "link_target": "_blank",
            "src_type": "div"
          },
          "image4": {
            "src": "https://i.pinimg.com/736x/1e/35/04/1e3504c3d3b8c3f0168ba0ca7483ea81.jpg",
            "title": "Сапфир-ага",
            "link_url": "https://ru.pinterest.com/pin/4222193394957418/",
            "link_target": "_blank",
            "src_type": "div"
          },
          "image5": {
            "src": "https://i.pinimg.com/1200x/8b/cf/27/8bcf2724b581bc721a5bfb42b546f394.jpg",
            "title": "Чёрные вдовы",
            "link_url": "https://ru.pinterest.com/pin/1829656094774419/",
            "link_target": "_blank",
            "src_type": "div"
          },
          "imageStyle": { 
            "backgroundColor": "#508750",
            "boxShadow": "0 13px 22px 0 #00000066, 0 2px 5px #000000EE"
          }, 
          "imageBorder": {
            "borderWidth": 5,
            "borderStyle": "solid",
            "borderColor": "var(--force-contast-color)"
          }  
        },
        {
          "id": getID("vernissage"),
          "type": "vernissage",
          "animated": ["fadeInLeft", "fadeInRight"],
          "animated_delay": "waterfall",
          "design_type": 1,
          "hover_size": 7,
          "text": {
            "text": "<p>Вход на все фильмы бесплатный по регистрации!!!!<p>Расписание можно найти на сайте Москино, а также на страничке Посольства Республики Перу, например, во Вконтактике. Не пропустите!<p>Сейчас Колобок на открытии фестиваля посмотрел «Мистическую Розу»<p>Это такой важный урок..."
          },
          "cover": {
            "src": "https://i.pinimg.com/736x/6b/e9/ea/6be9eac584d8e2b65abdf0382eb94957.jpg",
            "title": "Борода-ч",
            "link_url": "https://ru.pinterest.com/pin/16466354884525855/",
            "link_target": "_blank",
            "src_type": "div"
          },
          "coverTitle": { "text": "Harly Pottery" },
          "coverTitle2": { "text": "Nobody F.D." }, 
          "order": {
            "type": "data_content", 
            "id": getID("data_content"),
            "data": [
              {
                "type": "icon",
                "id": "icon-455643er-4567456",
                "style": {
                  "fontSize": 24,
                  "fontWeight": 100,
                  "textAlign": "center"
                },
                "src": "fas fa-home fa-1x"
              }
            ]
          },
          "image0": {
            "src": "https://i.pinimg.com/736x/c6/80/fa/c680fa93fdc531c98629e8990a086665.jpg",
            "title": "Турист",
            "link_url": "https://ru.pinterest.com/pin/70437488208712/",
            "link_target": "_blank",
            "src_type": "div"
          },
          "image1": {
            "src": "https://i.pinimg.com/736x/7d/a7/e1/7da7e19aee14701b13454ef950c42c1e.jpg",
            "title": "Тётя очкастая",
            "link_url": "https://ru.pinterest.com/pin/2392606045799310/",
            "link_target": "_blank",
            "src_type": "div"
          },
          "image2": {
            "src": "https://i.pinimg.com/1200x/33/9a/64/339a64446fdc6fbb2430a85ff2326950.jpg",
            "title": "Булобрыс",
            "link_url": "https://ru.pinterest.com/pin/1008384172853673933/",
            "link_target": "_blank",
            "src_type": "div"
          },
          "image3": {
            "src": "https://i.pinimg.com/736x/32/b9/3d/32b93d1894c49af0ea952ad815d167c5.jpg",
            "title": "Oldman",
            "link_url": "https://ru.pinterest.com/pin/18929260940792362/",
            "link_target": "_blank",
            "src_type": "div"
          },
          "image4": {
            "src": "https://i.pinimg.com/736x/ef/b4/a3/efb4a389cd2c7c254dc753211b88288c.jpg",
            "title": "Volandemorth",
            "link_url": "https://ru.pinterest.com/pin/73113193946355044/",
            "link_target": "_blank",
            "src_type": "div"
          },
          "image5": {
            "src": "https://i.pinimg.com/736x/e7/10/62/e710620c8c9babcccfc938a099ecf2cc.jpg",
            "title": "ghoster",
            "link_url": "https://ru.pinterest.com/pin/1125968742392482/",
            "link_target": "_blank",
            "src_type": "div"
          },
          "imageStyle": { 
            "backgroundColor": "#508750",
            "boxShadow": "0 13px 22px 0 #00000066, 0 2px 5px #000000EE"
          }, 
          "imageBorder": {
            "borderWidth": 5,
            "borderStyle": "solid",
            "borderColor": "var(--force-contast-color)"
          }  
        },
        {
          "id": getID("vernissage"),
          "type": "vernissage",
          "animated": ["fadeInLeft", "fadeInRight"],
          "animated_delay": "waterfall",
          "design_type": 2,
          "hover_size": 7,
          "text": {
            "text": "<p>Каким бы спорным это утверждение не показалось, однако дизайн интерьера в Советском Союзе все же был. Правду сказать, оформление квартир можно назвать топорным. Однако сочетать на первый взгляд несочетаемое в интерьере стало для советских граждан привычкой. Дефицит отделочных материалов и мебели доводил до такой необходимости. Но даже из того немногого, что предлагала отечественная промышленность, порой получались со вкусом обставленные комнаты.<p>Пожалуй, самый вместительный вариант корпусной мебели, изобретенный за всю историю человечества. И это не преувеличение. Со времен распада СССР люди увидели много новой мебели с красивым дизайном."
          },
          "cover": {
            "src": "https://i.pinimg.com/736x/9e/26/1f/9e261f8037c6e26fe093a747cc097f18.jpg",
            "link_url": "https://ru.pinterest.com/pin/1477812374025605/",
            "link_target": "_blank",
            "title": "Jannett",
            "src_type": "div"
          },
          "coverTitle": { "text": "Symophore" },
          "coverTitle2": { "text": "Janett" }, 
           "order": {
            "type": "data_content", 
            "id": getID("data_content"),
            "data": [
              {
                "type": "image",
                "id": getID("image"),
                "width": 100,
                "height": 100,
                "src": "https://i.pinimg.com/736x/9f/13/48/9f13480d95fa12cfc03cb4f50039e792.jpg",
                "src_type": "div"
              }
            ]
          },
          "image0": {
            "src": "https://i.pinimg.com/1200x/6a/23/94/6a239476001887a3a03847cbce160e5c.jpg",
            "link_url": "https://ru.pinterest.com/pin/4292562140482618/",
            "link_target": "_blank",
            "title": "Майк Эрмантраут",
            "src_type": "div"
          },
          "image1": {
            "src": "https://i.pinimg.com/736x/db/95/1c/db951ccbaaa5d688c657329d82b33dad.jpg",
            "link_url": "https://ru.pinterest.com/pin/2111131070220008/",
            "link_target": "_blank",
            "title": "Yaga",
            "src_type": "div"
          },
          "image2": {
            "src": "https://i.pinimg.com/736x/a1/96/0d/a1960da87791c173b5cb889aa1ea5290.jpg",
            "link_url": "https://ru.pinterest.com/pin/572309065167812417/",
            "link_target": "_blank",
            "title": "Magnitto",
            "src_type": "div"
          },
          "image3": {
            "src": "https://i.pinimg.com/1200x/7f/6b/c9/7f6bc92a5d680dd930c6cb689b176db9.jpg",
            "link_url": "https://ru.pinterest.com/pin/634655772531452254/",
            "link_target": "_blank",
            "title": "Мерфи",
            "src_type": "div"
          },
          "image4": {
            "src": "https://i.pinimg.com/736x/c9/68/15/c96815dd7ca79ec846a1ea650f73acb6.jpg",
            "link_url": "https://ru.pinterest.com/pin/834221531020384947/",
            "link_target": "_blank",
            "title": "Звезда",
            "src_type": "div"
          },
          "image5": {
            "src": "https://i.pinimg.com/736x/48/3f/49/483f49355f3708359f681b91cb9eed84.jpg",
            "link_url": "https://ru.pinterest.com/pin/834221531020384947/",
            "link_target": "_blank",
            "title": "Морда",
            "src_type": "div"
          },
          "imageStyle": { 
            "backgroundColor": "#75a5c5ff",
            "boxShadow": "0 13px 22px 0 #00000066, 0 2px 5px #000000EE"
          }, 
          "imageBorder": {
            "borderWidth": 5,
            "borderStyle": "solid",
            "borderColor": "var(--force-contast-color)"
          }  
        },
        {
          "id": getID("vernissage"),
          "type": "vernissage",
          "animated": ["fadeInLeft", "fadeInRight"],
          "animated_delay": "waterfall",
          "design_type": 3,
          "hover_size": 7,
          "text": {
            "text": "<p>Посмотрел занятный сериал «Вождь войны» про разборки туземцев на Гавайях в первой половине XIX века.<p>Тема прямо скажем не заезженная + с претензией на связь с историческими событиями.<p>Гавайи в тот период были поделены на 4 королевства туземцев, которые воевали между собой, периодически вырезая оппонентов на соседнем острове.<p>Каждому королю по большому острову."
          },
          "cover": {
            "src": "https://i.pinimg.com/736x/be/41/7e/be417e972e71baf34e83e7e2ccc4418d.jpg",
            "title": "Кабуки",
            "link_url": "https://ru.pinterest.com/pin/4574037116523710/",
            "link_target": "_blank",
            "src_type": "div"
          },
          "coverTitle": { "text": "Боrоdaчоk" },
          "coverTitle2": { "text": "Ctаричоk" }, 
           "order": {
            "type": "data_content",            
            "id": getID("data_content"),
            "data": [
              {
                "type": "image",
                "id": getID("image"),
                "width": 100,
                "height": 100,
                "src": "https://i.pinimg.com/736x/88/8e/74/888e74b3c88b38aa6c25f7ee3552668c.jpg",
                "src_type": "div"
              }
            ]
          },
          "image0": {
            "src": "https://i.pinimg.com/736x/fc/6b/be/fc6bbef38e2f3cdba7f8174d2b1c7f51.jpg",
            "title": "Улитка",
            "link_url": "https://ru.pinterest.com/pin/4996249583009452/",
            "link_target": "_blank",
            "src_type": "div"
          },
          "image1": {
            "src": "https://i.pinimg.com/736x/b5/c2/da/b5c2daebf8055bf2d07126f3cf12fec0.jpg",
            "title": "Головоя",
            "link_url": "https://ru.pinterest.com/pin/3096293489679736/",
            "link_target": "_blank",
            "src_type": "div"
          },
          "image2": {
            "src": "https://i.pinimg.com/736x/57/67/d1/5767d16d80e10536657ffbd438b16fd4.jpg",
            "title": "Фея",
            "link_url": "https://ru.pinterest.com/pin/6122149488075237/",
            "link_target": "_blank",
            "src_type": "div"
          },
          "image3": {
            "src": "https://i.pinimg.com/1200x/05/ce/7d/05ce7dfa8f713b8b0d23e641bb719836.jpg",
            "title": "Дриада",
            "link_url": "https://ru.pinterest.com/pin/2744449768046241/",
            "link_target": "_blank",
            "src_type": "div"
          },
          "image4": {
            "src": "https://i.pinimg.com/736x/d8/0f/ba/d80fbab94099dd3b7c18089ce05c7013.jpg",
            "title": "Кибер-цветуёчеk",
            "link_url": "https://ru.pinterest.com/pin/6333255724338637/",
            "link_target": "_blank",
            "src_type": "div"
          },
          "image5": {
            "src": "https://i.pinimg.com/736x/89/bb/79/89bb792df6634b94e089926b4bb9b511.jpg",
            "title": "Медведь-мореход",
            "link_url": "https://ru.pinterest.com/pin/33284484740779433/",
            "link_target": "_blank",
            "src_type": "div"
          },
          "imageStyle": { 
            "backgroundColor": "#508750",
            "boxShadow": "0 13px 22px 0 #00000066, 0 2px 5px #000000EE"
          }, 
          "imageBorder": {
            "borderWidth": 5,
            "borderStyle": "solid",
            "borderColor": "var(--force-contast-color)"
          }  
        }
    ]
}

export default vernissage